module.exports = __webpack_public_path__ + "static/media/git.4d5ed62c.png";